import React from "react";
import { Building2, UserRound } from "lucide-react";

const OPTIONS = [
  { value: "formal", icon: Building2, title: "Compra formal", desc: "El proveedor tiene RNC y te entrega su comprobante electrónico (E31…)." },
  { value: "informal", icon: UserRound, title: "Compra informal", desc: "Persona sin RNC que no puede darte comprobante. Amelia emite el E41." },
];

export function PurchaseKindPicker({ value, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="purchase-kind-picker">
      {OPTIONS.map(({ value: v, icon: Icon, title, desc }) => {
        const active = value === v;
        return (
          <button key={v} type="button" onClick={() => onChange(v)} data-testid={`purchase-kind-${v}`}
            className={`text-left rounded-md border p-4 transition-colors ${active ? "border-primary bg-primary/5 ring-1 ring-primary" : "border-border hover:border-primary/60"}`}>
            <div className="flex items-center gap-2 font-bold"><Icon className="w-4 h-4 text-primary" />{title}</div>
            <p className="text-xs text-muted-foreground mt-1">{desc}</p>
          </button>
        );
      })}
    </div>
  );
}

export function YesNo({ value, onChange, testid }) {
  const btn = (v, label) => (
    <button type="button" onClick={() => onChange(v)} data-testid={`${testid}-${v ? "yes" : "no"}`}
      className={`px-4 h-9 rounded-md border text-sm font-semibold transition-colors ${value === v ? "border-primary bg-primary text-primary-foreground" : "border-border hover:border-primary/60"}`}>
      {label}
    </button>
  );
  return <div className="flex gap-2">{btn(true, "Sí")}{btn(false, "No")}</div>;
}
